import * as yup from "yup";

export const yupStrictPassword = yup
  .string()
  .required()
  .min(8, "Must contain at least 8 characters.")
  .matches(/^(?=.*[A-Z])/, "Must contain at least one uppercase character.")
  .matches(/^(?=.*[a-z])/, "Must contain at least one lowercase character.")
  .matches(
    /^(?=.*[0-9])|(?=.*[!@#\$%\^&\*])/,
    "Must contain at least one number or special character, (e.g., ! @ # $ % ^ & *)",
  );

export const yupPasswordConfirmation = yup
  .string()
  .oneOf([yup.ref("password")], "Passwords do not match")
  .required("Password confirmation is required");

export const yupPassword = yup
  .string()
  .min(6, "Password should have at least 6 characters")
  .required("Password is required");

export const yupEmail = yup
  .string()
  .email("Please enter a valid email")
  .required("Email is required");

export const REQUIRED_MSG = "This is a required field";

export const yupRequired = yup.string().nullable().required(REQUIRED_MSG);
